import { PurchaseOrder } from '../../../clients/quipli-service/purchase-order/purchase-order';
import { Modal } from '../../../components/modal/modal';
import { Button } from '../../../components/form/button';
import { useState } from 'react';
import { usePurchaseOrderApiV1 } from '../../../clients/quipli-service/purchase-order/purchase-order-api-v1';
import { Spinner } from '../../../components/spinner/spinner';
import { toast } from '../../../util/toasts';

export const ReceivePurchaseOrder = ({
  order,
  onCancel,
  onComplete,
}: {
  order: PurchaseOrder;
  onCancel: () => void;
  onComplete: () => void;
}) => {
  const { receivePurchaseOrder } = usePurchaseOrderApiV1();

  const [isReceiving, setIsReceiving] = useState<boolean>(false);

  const doReceive = async () => {
    setIsReceiving(true);
    try {
      await receivePurchaseOrder(order.id);
      onComplete();
    } catch (e: any) {
      toast(e.message || 'Failed to receive purchase order', 'error');
      setIsReceiving(false);
    }
  };

  return (
    <Modal
      isOpen={true}
      title="Receive Purchase Order"
      additionalText="All items will be added to inventory."
      actions={
        isReceiving ? (
          <Spinner />
        ) : (
          <>
            <Button className="button button-secondary" onClick={() => onCancel()}>
              Cancel
            </Button>
            <Button
              dataCy="approve-purchase-order-modal"
              className="button button-yellow"
              // disabled={!isValid}
              onClick={() => doReceive()}
            >
              Receive
            </Button>
          </>
        )
      }
      close={() => !isReceiving && onCancel()}
    ></Modal>
  );
};
